<template>
  <Wrapper>
    <Topo />
    <InternaMain
      class="paddingBottomNone"
      maxwidth-container="820px"
      sem-menu-lateral
    >
      <RastreioTimeline
        v-if="rastreioNoStore"
        :dados-rastreio="rastreio"
      />

      <template v-else-if="!erro">
        <TituloRastreio />

        <v-card-text class="subtitle-2 pa-0 blue--text mt-2 mb-2">
          Clique abaixo para prosseguir e ver o status de sua compra
        </v-card-text>

        <VueRecaptcha
          class="recaptcha"
          load-recaptcha-script
          :sitekey="recaptchaKey"
          @verify="buscarRastreio"
        />
      </template>

      <div
        v-else
        class="container-erro"
      >
        <div class="row-erro">
          <v-alert
            class="elevation-1 pt-5 pb-5 mb-0"
            dense
            outlined
            type="info"
          >
            <p class="mb-0">
              {{ erro }}
            </p>
          </v-alert>
        </div>
      </div>
    </InternaMain>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import InternaMain from '@/components/InternaMain.vue';
import RastreioTimeline from '@/components/Rastreio/RastreioTimeline.vue';
import TituloRastreio from '@/components/Login/TituloRastreio.vue';
import { mapGetters, mapActions } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';
import apiRastreio from '@/api/rastreio';
import isCenterpagEnvironment from '../utils/environment';

export default {
  name: 'AcompanharEnvioNaoLogado',

  components: {
    Wrapper,
    Topo,
    InternaMain,
    RastreioTimeline,
    VueRecaptcha,
    TituloRastreio,
  },

  props: {
    namePath: {
      type: String,
      default: '',
    },
    codigoRastreio: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    recaptchaKey: isCenterpagEnvironment()
      ? process.env.VUE_APP_RECAPTCHA_CENTERPAG_KEY
      : process.env.VUE_APP_RECAPTCHA_KEY,
    loading: false,
    erro: '',
  }),

  computed: {
    ...mapGetters(['rastreio']),

    rastreioNoStore() {
      return this.rastreio && this.rastreio.tracking_code === this.codigoRastreio;
    },
  },

  methods: {
    ...mapActions(['buscarDadosRastreio']),

    async buscarRastreio(recaptchaToken) {
      this.loading = true;
      try {
        await this.buscarDadosRastreio({
          apiRastreio,
          recaptchaToken,
          codigoRastreio: this.codigoRastreio,
          namePath: this.namePath,
        });
      } catch (error) {
        this.erro = error.message;
      }

      this.loading = false;
    },
  },
};

</script>

<style lang="scss">
  .paddingBottomNone{
    padding-bottom: 0!important
  }

  .container-erro {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: calc(100% - 36px) !important;
  }

  .row-erro {
    display: flex;
    justify-content: center;
  }

  .v-alert {
    width: fit-content;
  }
</style>
